module.exports = "images/france-5.983340a4.png";